'use client';

import React from 'react';
import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';
import FilterPill from '@/components/molecules/filter-pill';
import { classnames } from '@/utils/classnames/classnames';
import { FilterToolbarProps } from './types';

// EWM-185 inline filter toolbar.
//
// Single horizontal row above the product grid. Order matches the v0
// mock: All Filters trigger on the left, vertical divider, then the
// FilterPill molecules (Brand / Price / etc). Pure layout/composition
// — pill state is owned by the caller, drawer state is owned by the
// page.
const FilterToolbar = ({
  pills,
  onPillChange,
  onAllFiltersClick,
  totalActiveCount = 0,
  className = '',
}: FilterToolbarProps) => {
  return (
    <div className={classnames('flex flex-wrap items-center gap-2', className)} role="toolbar" aria-label="Filters">
      {onAllFiltersClick && (
        <>
          <button
            type="button"
            onClick={onAllFiltersClick}
            className={classnames(
              'text-13 inline-flex items-center gap-2 rounded-full border px-4 py-2 font-medium transition-colors',
              'focus:ring-primary/40 focus:ring-2 focus:outline-hidden',
              totalActiveCount > 0
                ? 'border-primary text-primary hover:bg-neutral-150'
                : 'border-gray-300 bg-white text-gray-700 hover:border-gray-400',
            )}
            aria-label="Open all filters"
          >
            <AdjustmentsHorizontalIcon className="size-4" aria-hidden />
            <span>
              All Filters
              {totalActiveCount > 0 && <span className="text-12 ml-1 font-normal">({totalActiveCount})</span>}
            </span>
          </button>

          <div aria-hidden className="mx-1 h-6 w-px bg-gray-300" />
        </>
      )}

      {pills.map((pill) => (
        <FilterPill
          key={pill.id}
          label={pill.label}
          options={pill.options}
          value={pill.value}
          onChange={(next) => onPillChange?.(pill.id, next)}
        />
      ))}
    </div>
  );
};

export default FilterToolbar;
